module.exports = "/img/LeftArrow.c79203.png";